var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"relative"},[(_vm.loading)?_c('div',{staticClass:"rounded-lg flex items-center justify-center absolute inset-0 z-10",class:_vm.modeClass},[_c('loader',{staticClass:"text-60"})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }